import { FileType } from "@common/constants/financial-documents";

export const RECONCILIATION_FILE_TYPES: readonly FileType[] = [FileType.PDF];
export const IMPORTER_FILE_TYPES: readonly FileType[] = [
    FileType.PDF,
    FileType.CSV,
    FileType.JPG,
    FileType.JPEG,
    FileType.PNG,
];
export const RECONCILIATION_FILE_TYPES_NAMES = "PDFs";
export const IMPORTER_FILE_TYPES_NAMES = "PDFs, CSVs, and images";
